/** Evita desfase UTC al parsear "YYYY-MM-DD" desde inputs type=date. */
function toDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    const [y, m, d] = value.trim().split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * Ej.: 21-Mar-2026
 */
export function formatDateDMY(value) {
  const d = toDate(value);
  if (!d) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const mon = MONTHS[d.getMonth()];
  return `${day}-${mon}-${d.getFullYear()}`;
}

/**
 * Fecha + hora (24h), ej.: 21-Mar-2026 14:30
 */
export function formatDateTimeDMY(value) {
  const d = toDate(value);
  if (!d) return "—";
  const datePart = formatDateDMY(d);
  const timePart = d.toLocaleTimeString("es-CL", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
  return `${datePart} ${timePart}`;
}
